import {PROFILE_ENDPOINT} from "../api-services/ApiEndpoints";

export const getProfile = async () => {
    const url = `${process.env.REACT_APP_API_URL}${PROFILE_ENDPOINT}`;
    const token = localStorage.getItem('token');
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return await response.json();
};